<footer class="footer mt-auto py-3 bg-light">
  <div class="container">
    <div class="footer-content">
      <span class="text-muted">
        &copy; {{ currentYear }} CentralMed. Todos los derechos reservados.
      </span>
      <ng-container *ngIf="mostrarTerminos && tipoUsuario">
        <span class="separator">|</span>
        <a [routerLink]="'/' + tipoUsuario + '/terminos-y-condiciones'" class="text-muted text-decoration-none">
          Términos y Condiciones
        </a>
      </ng-container>
    </div>
  </div>
</footer>
